// src/components/dashboard/CreatePollModal.js
// Updated: 10/17/2025 01:31 PM

import React, { useState } from 'react';
import { db } from '../../firebase/config';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import toast from 'react-hot-toast';
import Spinner from '../common/Spinner';
import ModalWrapper from '../common/ModalWrapper';
import { FaPlus, FaTrash } from 'react-icons/fa';

const CreatePollModal = ({ familyId, eventId, onClose }) => {
  const [question, setQuestion] = useState('');
  const [options, setOptions] = useState([{ id: 1, text: '' }, { id: 2, text: '' }]);
  const [loading, setLoading] = useState(false);

  const handleOptionChange = (id, value) => {
    setOptions(options.map(opt => (opt.id === id ? { ...opt, text: value } : opt)));
  };

  const addOption = () => {
    setOptions([...options, { id: Date.now(), text: '' }]);
  };

  const removeOption = (id) => {
    setOptions(options.filter(opt => opt.id !== id));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formattedOptions = options
      .filter(opt => opt.text.trim() !== '')
      .map(opt => ({ text: opt.text, votes: 0 }));

    if (formattedOptions.length < 2) {
      toast.error("Please provide at least two valid options.");
      setLoading(false);
      return;
    }

    try {
      const pollsRef = collection(db, `families/${familyId}/events/${eventId}/polls`);
      await addDoc(pollsRef, {
        question,
        options: formattedOptions,
        voters: [], // Array to store user IDs who have voted
        createdAt: serverTimestamp(),
      });

      toast.success('Poll created successfully!');
      onClose();
    } catch (error) {
      console.error("Error creating poll: ", error);
      toast.error('Failed to create poll.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalWrapper onClose={onClose} size="lg">
      <div className="p-6 border-b"><h3 className="text-xl font-semibold text-neutral-gray">Create a New Poll</h3></div>
      <form onSubmit={handleSubmit}>
        <div className="p-6 space-y-4 max-h-[70vh] overflow-y-auto">
          <div><label htmlFor="poll-question" className="block text-sm font-medium text-gray-700">Question</label><input type="text" id="poll-question" value={question} onChange={(e) => setQuestion(e.target.value)} required className="mt-1 w-full border-gray-300 rounded-md shadow-sm"/></div>
          <div className="pt-2"><h4 className="text-md font-medium text-gray-700 mb-2">Options</h4>
            <div className="space-y-2">
              {options.map((opt) => (
                <div key={opt.id} className="flex items-center gap-2">
                  <input type="text" placeholder={`Option ${options.indexOf(opt) + 1}`} value={opt.text} onChange={(e) => handleOptionChange(opt.id, e.target.value)} className="w-full border-gray-300 rounded-md shadow-sm"/>
                  {options.length > 2 && <button type="button" onClick={() => removeOption(opt.id)} className="text-red-500 hover:text-red-700 p-2"><FaTrash /></button>}
                </div>
              ))}
            </div>
            <button type="button" onClick={addOption} className="mt-3 flex items-center gap-2 text-sm text-primary font-semibold hover:underline"><FaPlus size={12} /> Add Option</button>
          </div>
        </div>
        <div className="p-6 bg-gray-50 rounded-b-lg flex justify-end items-center gap-4">
          <button type="button" onClick={onClose} className="px-4 py-2 bg-white border border-gray-300 rounded-md text-sm font-medium hover:bg-gray-50">Cancel</button>
          <button type="submit" disabled={loading} className="px-4 py-2 bg-success text-white rounded-md hover:bg-green-700 text-sm font-medium disabled:opacity-50 flex items-center">{loading ? <Spinner size="sm" /> : 'Create Poll'}</button>
        </div>
      </form>
    </ModalWrapper>
  );
};

export default CreatePollModal;